import { Table } from "react-bootstrap";
import formatDollars from "../../../../../utilities/currency-formatter";
import styles from "../../../../../styles/screening.module.css";

const CostEstimateSummary = ({ services = [],supplies = [],oneTimeCosts = [] }) => {

    const serviceTotal = services.reduce((sum,current) => sum + current.total,0);
    const supplyTotal = supplies.reduce((sum,current) => sum + current.total,0);
    const onetimetotal = oneTimeCosts.reduce((sum,current) => sum + current.total,0);

    const grandTotal = serviceTotal + supplyTotal + onetimetotal;

    return (
        <div className="clientCard">
            <div className="clientCardInner">
                <h4 className="text-center">Cost Estimate</h4>
                <Table bordered striped size="sm" className={styles.responsiveTable}>
                    <thead>
                        <tr className="text-center align-middle">
                            <th>SERVICES</th>
                            <th></th>
                            <th>SUPPLIES</th>
                            <th></th>
                            <th>ONE TIME COSTS</th>
                            <th></th>
                            <th>GRAND TOTAL COSTS</th>
                        </tr>
                    </thead>
                    <tbody className="text-center align-middle">
                        <tr>
                            <td>{formatDollars(serviceTotal)}</td>
                            <td className="fw-bold">+</td>

                            <td>{formatDollars(supplyTotal)}</td>

                            <td className="fw-bold">+</td>

                            <td>{formatDollars(onetimetotal)}</td>

                            <td className="fw-bold">=</td>

                            <td className={`fw-bolder fs-4`}>{formatDollars(grandTotal)}</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        </div>
    )
}

export default CostEstimateSummary;